import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'hedron';
import CreditCardLogo from '../../components_mobile/components/CreditCardLogo';
import { Wrapper } from '../../components_desktop/css_global/utils.css';

const ReviewsCreditCards = props => {
  const { isDesktop, isUsdOrder } = props;

  return (
    <div>
      <Wrapper padding="0 15px" uppercase>
        <p style={{ fontFamily: '"Avenir", "Arial", sans-serif', fontWeight: 900 }}>
          Safe and secure shopping & fast express shipping
        </p>
        <Row alignItems="center" justifyContent="space-evenly">
          <CreditCardLogo isDesktop={isDesktop} logoPath="mkt/icon/Visa-logo.jpg" />
          <CreditCardLogo isDesktop={isDesktop} logoPath="mkt/icon/visa_electron.jpg" />
          {isUsdOrder ? <CreditCardLogo isDesktop={isDesktop} logoPath="mkt/icon/jcb.png" /> : null}
          <CreditCardLogo isDesktop={isDesktop} logoPath="mkt/icon/Mastercard-PNG-Clipart.png" />
          <CreditCardLogo isDesktop={isDesktop} logoPath="mkt/icon/Logo+DHL_Express.png" />
        </Row>
      </Wrapper>
    </div>
  );
};

ReviewsCreditCards.propTypes = {
  isDesktop: PropTypes.bool.isRequired,
  isUsdOrder: PropTypes.bool.isRequired,
};

export default ReviewsCreditCards;
